module.exports = __webpack_public_path__ + "DINNextRoundedLTPro-Regular.woff?bdefee1d48a8c350a4aac08c7966f6da";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextRoundedLTPro-Regular.woff
// module id = 1419
// module chunks = 0